import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";
import { HeaderProvider } from "./context/HeaderHoverContext.jsx"; // Ajusta la ruta si es necesario
import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Router>
      <HeaderProvider>
        <App />
      </HeaderProvider>
    </Router>
  </React.StrictMode>
);
